export default {
  props: {
    name: {
      type: String,
      default: () => null,
    },
    options: {
      type: Array,
      default: () => ({}),
    },
    value: {
      type: Array,
      default: () => ([]),
    },
  },
  render(el) {
    return el('div', {}, this.options.map(({ text: description, value: key, tooltip }, i) => {
      const toggleChecked = () => {
        const i = this.value.indexOf(key);
        i >= 0 ? this.value.splice(i, 1) : this.value.push(key);
        console.log(this.value);
        this.$emit('input', this.value);
      };

      const props = {
        key,
        description,
        tooltip,
        checked: this.value.includes(key),
        fieldName: `${this.name || 'checkbox-group'}-${key}`,
        toggleChecked: toggleChecked.bind(null, key),
      };

      if (typeof this.$slots[`row(${key})`] === 'function') {
        return this.$slots[`row(${key})`].call(null, props);
      } else if (typeof this.$slots.item === 'function') {
        return this.$slots.item(props);
      } else {
        return el('div', { class: 'd-flex flex-row' }, [
          el('b-form-checkbox', {
            props: { checked: props.checked, name: props.fieldName },
            on: { change: value => props.toggleChecked(value) },
            ...(tooltip ? {
              directives: [ { name: 'b-tooltip', modifiers: { hover: true, left: true }, value: tooltip } ],
            } : {}),
          }, props.description || key),
        ]);
      }
    }));
  },
};



// WEBPACK FOOTER //
// ./src/components/settings/CheckboxGroup.js